import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const DOC_TYPES_KEYS = (t: $TSMigrationFixMe) => {
  return {
    2: {
      label: `${t("documentos.validar.select.invoceLabel")}`,
      id: "Factura",
      value: 2,
      flujoAprobaciones: [],
      icon: "file-invoice",
      plural: `${t("documentos.validar.select.invoceLabel")}s`,
    },
    18: {
      label: `${t("documentos.validar.select.deliveryLabel")}`,
      value: 18,
      id: "Albarán",
      flujoAprobaciones: [],
      icon: "file-contract",
      plural: `${t("documentos.validar.select.deliveryLabel")}es`,
    },
    24: {
      label: `${t("documentos.validar.select.orderLabel")}`,
      value: 24,
      id: "Pedido",
      flujoAprobaciones: [],
      icon: "file-lines",
      plural: `${t("documentos.validar.select.orderLabel")}s`,
    },
    25: {
      label: `${t("documentos.validar.select.quotationLabel")}`,
      value: 25,
      id: "Presupuesto",
      flujoAprobaciones: [],
      icon: "file",
      plural: `${t("documentos.validar.select.quotationLabel")}s`,
    },
  }
}

export const DOC_TYPES_OPTIONS = (t: $TSMigrationFixMe) => [
  { label: `${t("types.invoce")}`, value: 2 },
  { label: `${t("types.delivery")}`, value: 18 },
  { label: `${t("types.order")}`, value: 24 },
  { label: `${t("types.burget")}`, value: 25 },
]

export const RANGE_OPTIONS = (t: $TSMigrationFixMe) => [
  { label: `${t("ranges.asWell")}`, value: 0 },
  { label: `${t("ranges.greaterThan")}`, value: 1 },
  {
    label: `${t("ranges.lessThan")}`,
    value: 2,
  },
  { label: `${t("ranges.greaterThanOrEqual")}`, value: 3, symbol: "≥" },
  { label: `${t("ranges.lessThanOrEqual")}`, value: 4 },
  { label: `${t("ranges.between")}`, value: 5 },
  { label: `${t("ranges.all")}`, value: 999 },
]

export const mapDepartamentosToSelect = (departamentos: $TSMigrationFixMe) => {
  return departamentos?.map((departamento: $TSMigrationFixMe) => {
    return {
      label: departamento?.nombre,
      value: departamento?.id,
    }
  })
}

export const mapDepartamentosSelectToEtapas = (
  departamentos: $TSMigrationFixMe
) => {
  return departamentos?.map((departamento: $TSMigrationFixMe) => {
    return {
      departamentoId: departamento?.departamentoId,
      numeroFirmas: departamento.numeroFirmas,
      orden: departamento.orden,
      departamentoNombre: departamento.departamentoNombre,
    }
  })
}

export const SYMBOL_RANGE = {
  0: (
    <FontAwesomeIcon
      icon={["fal", "equals"]}
      className='inequity-icons tw-h-3'
    />
  ),
  1: (
    <FontAwesomeIcon
      icon={["fas", "greater-than"]}
      className='inequity-icons tw-h-3'
    />
  ),
  2: (
    <FontAwesomeIcon
      icon={["fas", "less-than"]}
      className='inequity-icons tw-h-3'
    />
  ),
  3: (
    <FontAwesomeIcon
      icon={["fas", "greater-than-equal"]}
      className='inequity-icons tw-h-3'
    />
  ),
  4: (
    <FontAwesomeIcon
      icon={["fas", "less-than-equal"]}
      className='inequity-icons tw-h-3'
    />
  ),
}

export const NAME_TYPE = {
  Factura: "Facturas",
  Albarán: "Albaranes",
  Pedido: "Pedidos",
  Presupuesto: "Presupuestos",
}

export const DEFAULT_APROBACIONES_LIST = (t: $TSMigrationFixMe) => [
  {
    flujoAprobaciones: DOC_TYPES_KEYS(t)[2].flujoAprobaciones,
    tipoDocumentoNombre: DOC_TYPES_KEYS(t)[2].label,
    value: DOC_TYPES_KEYS(t)[2].value,
  },
  {
    flujoAprobaciones: DOC_TYPES_KEYS(t)[18].flujoAprobaciones,
    tipoDocumentoNombre: DOC_TYPES_KEYS(t)[18].label,
    value: DOC_TYPES_KEYS(t)[18].value,
  },
  {
    flujoAprobaciones: DOC_TYPES_KEYS(t)[24].flujoAprobaciones,
    tipoDocumentoNombre: DOC_TYPES_KEYS(t)[24].label,
    value: DOC_TYPES_KEYS(t)[24].value,
  },
  {
    flujoAprobaciones: DOC_TYPES_KEYS(t)[25].flujoAprobaciones,
    tipoDocumentoNombre: DOC_TYPES_KEYS(t)[25].label,
    value: DOC_TYPES_KEYS(t)[25].value,
  },
]

export const DEFAULT_AUTOVALIDACION = { label: "Autovalidación", value: 9999 }

export const generarteValidationsList = (
  aprobaciones: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const newArray = DEFAULT_APROBACIONES_LIST(t)?.map((element) => {
    const elementTest: $TSMigrationFixMe = []
    aprobaciones?.forEach((aprob: $TSMigrationFixMe) => {
      if (aprob.tipoDocumento === element.value) {
        return elementTest.push(aprob)
      }
    })
    if (elementTest.length) {
      return {
        ...element,
        flujoAprobaciones: elementTest,
      }
    }
    return element
  })
  return newArray
}

export const checkHasNotVerifiedRequirements = (
  flujoAprobaciones: $TSMigrationFixMe
) =>
  flujoAprobaciones.some(
    (element: $TSMigrationFixMe) => !element.todosLosRangos
  )

export const RANGE_SYMBOLS = (t: $TSMigrationFixMe) => {
  return {
    0: { label: `${t("ranges.asWell")}`, symbol: "=" },
    1: { label: `${t("ranges.greaterThan")}`, symbol: ">" },
    2: {
      label: `${t("ranges.lessThan")}`,
      symbol: "<",
    },
    3: { label: `${t("ranges.greaterThanOrEqual")}`, symbol: "≥" },
    4: { label: `${t("ranges.lessThanOrEqual")}`, symbol: "≤" },
    5: { label: `${t("ranges.between")}`, symbol: "entre" },
    999: { label: "", symbol: "" },
  }
}

export const DOC_TITLE_PLURAL = (t: $TSMigrationFixMe) => {
  return {
    Factura: `${t("documentos.validar.select.invoceLabel")}`,
    Albarán: `${t("documentos.validar.select.deliveryLabel")}`,
    Pedido: `${t("documentos.validar.select.orderLabel")}`,
    Presupuesto: `${t("documentos.validar.select.quotationLabel")}`,
  }
}

export const ALBARANES_OPTIONS = (t: $TSMigrationFixMe) => {
  return {
    singular: "Albarán",
    plural: `${t("crear.albaran.titleUpper")}`,
  }
}
